import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api/apiServises';
import {
  FETCH_SIDE_WALL_STAGE_ONE_FORM,
  DELETE_SIDE_WALL_STAGE_ONE,
  ADD_SIDE_WALL_QUALITY_CHECK,
  FETCH_SIDE_WALL_STAGE_ONE_LIST,
  UPDATE_SIDE_WALL_STAGE_ONE_DATA,
  FETCH_SIDE_WALL_STAGE_THREE_FORM,
  ADD_SIDE_WALL_STAGE_THREE,
  FETCH_SIDE_WALL_STAGE_THREE_LIST,
  DELETE_SIDE_WALL_STAGE_THREE,
  FETCH_SIDE_WALL_STAGE_TWO_FORM,
  DELETE_SIDE_WALL_STAGE_TWO,
  // FETCH_METAL_FRAME_NUMBER,
  FETCH_SIDE_WALL_STAGE_TWO_LIST,
  ADD_SIDE_WALL_STAGE_TWO,
  GET_SIDE_WALL_FRAME_NUMBERS,
  GET_SIDE_WALL_DRAWING_NUMBERS,
  FETCH_METAL_FRAME_NUMBER_SIDEWALL,
  DATA_GET_SIDE_WALLFLOW_HISTORY,
  GET_VIEW_SIDE_WALL_STAGE_ONE_DATA,
  GET_VIEW_SIDE_WALL_STAGE_TWO_DATA,
  GET_VIEW_SIDE_WALL_STAGE_THREE_DATA,
  UPDATE_ALL_ONE_ACTION_LATEST,
  // UPDATE_SIDEWALL_STAGE_TWO_ACTION,
} from '../../../api/apiConstant';

export const fetchSideWallStageOneForm = createAsyncThunk(
  'sideWall/fetchSideWallStageOneForm',
  async (sideWallType, { rejectWithValue }) => {
    try {
      console.log('sendData', sideWallType);
      const response = await api.post(FETCH_SIDE_WALL_STAGE_ONE_FORM, sideWallType);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to fetch');
    }
  },
);

export const deleteSideWallStageOne = createAsyncThunk(
  'sideWall/deleteSideWallStageOne',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_SIDE_WALL_STAGE_ONE}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to delete');
    }
  },
);

export const addSideWallStageOne = createAsyncThunk(
  'sideWall/addSideWallStageOne',
  async (formData, { rejectWithValue }) => {
    try {
      console.log('thunk formData:', formData);
      const response = await api.post(ADD_SIDE_WALL_QUALITY_CHECK, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to save');
    }
  },
);

export const fetchSideWallStageOneList = createAsyncThunk(
  'sideWall/fetchSideWallStageOneList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_SIDE_WALL_STAGE_ONE_LIST, {
        params: { ...params },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch');
    }
  },
);

export const updateSideWallStageOne = createAsyncThunk(
  'sideWall/updateSideWallStageOne',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await api.put(`${UPDATE_SIDE_WALL_STAGE_ONE_DATA}/${id}`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update');
    }
  },
);

export const addSideWallStageThree = createAsyncThunk(
  'sideWall/addSideWallStageThree',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_SIDE_WALL_STAGE_THREE, formData);
      return response.data;
    } catch (error) {
      console.error('Error in addSideWallStageThree:', error);
      return rejectWithValue(error.response?.data?.message || 'Failed to insert Stage-3 record');
    }
  },
);

// ==============================
// FETCH STAGE-3 LIST
// ==============================

export const fetchSideWallStageThreeList = createAsyncThunk(
  'sideWall/fetchSideWallStageThreeList',
  async (params, { rejectWithValue }) => {
    try {
      console.log('baby loves ', params);

      const response = await api.get(FETCH_SIDE_WALL_STAGE_THREE_LIST, {
        params: { ...params },
      });
      console.log('Stage-3 list response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching Stage-3 list:', error);
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch Stage-3 records');
    }
  },
);

// ==============================
// DELETE STAGE-3 RECORD
// ==============================

export const deleteSideWallStageThree = createAsyncThunk(
  'sideWall/deleteSideWallStageThree',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_SIDE_WALL_STAGE_THREE}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to delete Stage-3 record');
    }
  },
);

// ==============================
// FETCH STAGE-3 FORM DATA
// ==============================

export const fetchSideWallStageThreeForm = createAsyncThunk(
  'sideWall/fetchSideWallStageThreeForm',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_SIDE_WALL_STAGE_THREE_FORM, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch Stage-3 form data');
    }
  },
);

export const fetchSideWallStageTwoForm = createAsyncThunk(
  'sideWall/fetchSideWallStageTwoForm',
  async (sidewalltype, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_SIDE_WALL_STAGE_TWO_FORM, sidewalltype);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to fetch');
    }
  },
);

export const deleteSideWallStageTwo = createAsyncThunk(
  'sideWall/deleteSideWallStageTwo',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_SIDE_WALL_STAGE_TWO}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to delete');
    }
  },
);

export const fetchmetaltypeFrameNumbers = createAsyncThunk(
  'sideWall/fetchFrameNumbers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${FETCH_METAL_FRAME_NUMBER_SIDEWALL}`);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch frame numbers');
    }
  },
);

export const fetchSideWallStageTwoList = createAsyncThunk(
  'sideWall/fetchSideWallStageTwoList',
  async (paramsfilter, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_SIDE_WALL_STAGE_TWO_LIST, {
        params: { ...paramsfilter },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to fetch');
    }
  },
);

export const addSideWallStageTwo = createAsyncThunk(
  'sideWall/addSideWallStageTwo',
  async (formData, { rejectWithValue }) => {
    try {
      // console.log('thunk id:', id);
      console.log('thunk formData:', formData);
      // const url = id ? `${ADD_SIDE_WALL_STAGE_TWO}/${id}` : ADD_SIDE_WALL_STAGE_TWO;
      const response = await api.post(ADD_SIDE_WALL_STAGE_TWO, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to save');
    }
  },
);

export const fetchSideWallFrameNumbers = createAsyncThunk(
  'sideWall/fetchSideWallFrameNumbers',
  async (_, { rejectWithValue }) => {
    try {
      console.log('Fetching frame numbers from:', GET_SIDE_WALL_FRAME_NUMBERS);
      const response = await api.get(GET_SIDE_WALL_FRAME_NUMBERS);
      console.log('=== API Response for Frame Numbers ===');
      console.log('Full Response:', response);
      console.log('Response Data:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error in fetchSideWallFrameNumbers:', error);
      console.error('Error details:', error.message);
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch side wall frame numbers',
      );
    }
  },
);

export const fetchSideWallDrawingNumbers = createAsyncThunk(
  'sideWall/fetchSideWallDrawingNumbers',
  async (_, { rejectWithValue }) => {
    try {
      console.log('Fetching drawing numbers from:', GET_SIDE_WALL_DRAWING_NUMBERS);
      const response = await api.get(GET_SIDE_WALL_DRAWING_NUMBERS);
      console.log('Drawing Numbers API Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error in fetchSideWallDrawingNumbers:', error);
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch drawing numbers');
    }
  },
);

export const sideWallActionStageOne = createAsyncThunk(
  'sideWall/sideWallActionStageOne',
  async (action, { rejectWithValue }) => {
    try {
      const response = await api.post(`${UPDATE_ALL_ONE_ACTION_LATEST}`, { ...action });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Action failed');
    }
  },
);

export const fetchSideWallFlowHistory = createAsyncThunk(
  'sideWall/fetchSideWallFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(DATA_GET_SIDE_WALLFLOW_HISTORY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch history');
    }
  },
);

export const fetchSideWallFlowHistoryStageOne = createAsyncThunk(
  'sideWall/fetchSideWallFlowHistoryStageOne',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(DATA_GET_SIDE_WALLFLOW_HISTORY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch history');
    }
  },
);

//------------------------------- view Side wall ------------------

export const fetchViewSideWallStageOne = createAsyncThunk(
  'roof/fetchViewSideWallStageOne',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_VIEW_SIDE_WALL_STAGE_ONE_DATA, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch flow history',
      );
    }
  },
);
export const fetchViewSideWallStageTwo = createAsyncThunk(
  'roof/fetchViewSideWallStageTwo',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_VIEW_SIDE_WALL_STAGE_TWO_DATA, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch flow history',
      );
    }
  },
);
export const fetchViewSideWallStageThree = createAsyncThunk(
  'roof/fetchViewSideWallStageThree',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_VIEW_SIDE_WALL_STAGE_THREE_DATA, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch flow history',
      );
    }
  },
);

export const sideWallActionStageTwo = createAsyncThunk(
  'sideWall/sideWallActionStageTwo',
  async (action, { rejectWithValue }) => {
    try {
      const response = await api.post(`${UPDATE_ALL_ONE_ACTION_LATEST}`, { ...action });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Action failed');
    }
  },
);

export const fetchSideWallFlowHistoryStageTwo = createAsyncThunk(
  'sideWall/fetchSideWallFlowHistoryStageTwo',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(DATA_GET_SIDE_WALLFLOW_HISTORY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch history');
    }
  },
);

export const sideWallActionStageThree = createAsyncThunk(
  'sideWall/sideWallActionStageThree',
  async (action, { rejectWithValue }) => {
    try {
      const response = await api.post(`${UPDATE_ALL_ONE_ACTION_LATEST}`, { ...action });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Action failed');
    }
  },
);

export const fetchSideWallFlowHistoryStageThree = createAsyncThunk(
  'sideWall/fetchSideWallFlowHistoryStageThree',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(DATA_GET_SIDE_WALLFLOW_HISTORY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch history');
    }
  },
);
